<template>
  <div class="person content-continer">
    <!-- 搜索 -->
    <div class="continer-top base-content">
      <!-- 第一行 -->
      <el-row :gutter="10">
        <el-col :span="7">
          <div class="grid-content bg-purple">
            <span>人员名字</span>
            <input type="text" placeholder="请输入人员名字" v-model="crcName" />
          </div>
        </el-col>
        <el-col :span="7">
          <div class="grid-content bg-purple">
            <span>项目名称</span>
            <input type="text" placeholder="请输入项目名称" v-model="projectName" />
          </div>
        </el-col>
        <el-col :span="7">
          <div class="grid-content bg-purple">
            <span>星级</span>
            <el-select v-model="startNum" placeholder="请选择">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="3" style="text-align:right;">
          <div class="grid-content bg-purple">
            <el-button type="primary" icon="el-icon-search" @click="crcManager(1)">搜索</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 人员列表 -->
    <div class="continer-title base-content" style="position:relative">
      <div class="blue">人员信息</div>
      <div class="crcTotal blue">共{{managerlist.length}}人</div>
      <p class="buit-btn right" style="margin-top:-15px;" @click="newbuit=true">
        <router-link to="/CIndex/addperson">
          <img src="../assets/hospital-img/add.png" />添加CRC人员
        </router-link>
      </p>
    </div>
    <div class="list-persons-content base-content" v-if="total">
      <el-row :gutter="25">
        <el-col :span="8" v-for="(item,index) in managerlist" :key="index">
          <div class="msg-list">
            <div>
              <p class="hover-msg">
                <a class="ck-msg" @click="previewMsg(item.crcId)">查看详情</a>
              </p>
              <!-- 空闲-->
              <a class="j-status" v-if="item.delegateState=='0'">
                <img src="../assets/hospital-img/free.png" />
              </a>
              <!-- 待接收 -->
              <a class="j-status" v-if="item.delegateState=='1'">
                <img src="../assets/hospital-img/jx.png" />
              </a>
              <p class="doctor-img">
                <img :src="imgurl+item.headImg" />
              </p>
              <p class="doctor-msg">
                <span class="doctor-name">{{item.crcName}}</span>
                <br />
                <span class="doctor-class">
                  <span>CRC人员</span>
                  <br />
                  <span v-for="items in item.goodAts" :key="items">{{items}}</span>
                </span>
                <span>
                  <i
                    class="el-icon-star-on"
                    v-for="(items,sum) in 5"
                    :class="sum+1<=item.starNum?'ling':''"
                    :key="sum"
                  ></i>
                </span>
              </p>
            </div>
            <div>
              <span class="left">{{item.hospitalName?item.hospitalName:''}}</span>
              <!-- <span class="right">{{item.projectNum?item.projectNum:'0'}}个项目</span> -->
              <!-- <span class="right-left" v-show="item.projectNum==0">暂无项目</span>
              <span class="right" v-show="item.projectNum!=0">{{item.projectNum}}个项目</span>-->
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="center" style="margin-bottom: 100px;" v-if="total">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="crcManager"
        :page-size="6"
      ></el-pagination>
    </div>
    <div class="center" style="margin-top: 100px;" v-if="total==''">暂无数据</div>
    <!-- 查看详情弹出框 -->
    <div class="preview-modal" v-if="peviewstatus">
      <Preview @peviewstatus="closePeview" :childid="childid"></Preview>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Preview from "../components/preview";
import { Cperson } from "@/request/api";
export default {
  name: "person",
  data() {
    return {
      options: [
        {
          value: "3",
          label: "CRC人员"
        },
        {
          value: "4",
          label: "CRA人员"
        }
      ],
      options2: [
        {
          value: "1",
          label: "一星以上"
        },
        {
          value: "2",
          label: "二星以上"
        },
        {
          value: "3",
          label: "三星以上"
        },
        {
          value: "4",
          label: "四星以上"
        },
        {
          value: "5",
          label: "五星"
        },
         {
          value: "",
          label: "不限"
        }
      ],
      peviewstatus: false,
      childid: "",
      pageNow: 1,
      userId: "",
      total: "",
      managerlist: [],
      crcName: "", //人员名称
      projectName: "", //项目名称
      startNum: "", //星级
      imgurl: this.Common.imgurl
    };
  },
  methods: {
    previewMsg(crcId) {
      this.childid = crcId;
      this.peviewstatus = true;
    },
    closePeview(data) {
      this.peviewstatus = data;
    },
    // 人员列表
    crcManager(event) {
      this.pageNow = event;
      let data = {
        pageIndex: this.pageNow,
        pageSize: 6,
        userId: this.userId,
        startNum: this.startNum,
        projectName: this.projectName,
        crcName: this.crcName
      };
      Cperson(data)
        .then(res => {
          console.log(res.data.data);
          let pagedata = res.data.data;
          this.managerlist = pagedata.list;
          this.total = pagedata.total;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    // crc人员列表
    this.userId = Cookies.get("userid");
    this.crcManager();
  },
  components: {
    Preview: Preview
  }
};
</script>
<style scoped>
.grid-content span:first-child {
  width: 60px;
}

.el-row {
  margin-bottom: 20px;
}

.ling {
  color: #f00;
}
.buit-btn a {
  color: #3672bf;
}
.crcTotal {
  font-size: 12px;
  font-weight: bold;
  width: 60px;
  height: 26px;
  background: #e0eefe;
  text-align: center;
  line-height: 26px;
  position: absolute;
  top: 28px;
  left: 108px;
}
</style>


// WEBPACK FOOTER //
// src/company/person-mange.vue